// routes.js
import React from "react";
import { useSelector } from "react-redux";

// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import UsersDashboard from "views/admin/users";
import OrderDetails from "views/admin/order/order-details";
import ContainerDetails from "views/admin/container/container-details";
import OrderCreate from "views/admin/order/create-orders";
import OrderEdit from "views/admin/order/draft-orders";
import OrderPage from "views/admin/order/order-page";
import ContainerPage from "views/admin/container/container-page";

// Icons
import { MdHome, MdOutlineShoppingCart, MdPerson } from "react-icons/md";
import { FiBox } from "react-icons/fi";
import { ImUsers } from "react-icons/im";
import { GiPartyPopper } from "react-icons/gi";
import AnnouncementDashboard from "views/admin/announcement";

const RoutesConfig = () => {
  const { orderStatusData } = useSelector((state) => state.orders);
  const { containerStatusData } = useSelector((state) => state.containers);

  const { permissions } = useSelector((state) => state.auth);

  const dynamicOrderRoutes =
    orderStatusData?.map((status) => ({
      name: status.name,
      layout: "/admin",
      path: `orders/${status.enumVal}`,
      component: <OrderPage status={status} />,
    })) || [];
  const dynamicContainerRoutes =
    containerStatusData?.map((status) => ({
      name: status.name,
      layout: "/admin",
      path: `containers/${status.enumVal}`,
      component: <ContainerPage status={status} />,
    })) || [];

  const routes = [
    permissions?.dashboard?.tab && {
      name: "Dashboard",
      layout: "/admin",
      path: "dashboard",
      icon: <MdHome className="h-6 w-6" />,
      component: <MainDashboard />,
    },
    permissions?.order?.tab && {
      name: "Orders",
      layout: "/admin",
      path: "orders",
      icon: <MdOutlineShoppingCart className="h-6 w-6" />,
      secondary: true,
      children: [
        ...dynamicOrderRoutes, // ✅ Inject dynamic children

        // {
        //   name: "Placed Orders",
        //   layout: "/admin",
        //   path: "purchase-orders",
        //   component: <PlacedOrder />,
        // },
        {
          name: "Order Details",
          layout: "/admin",
          path: "orders/:id",
          component: <OrderDetails />,
          hidden: true,
        },
        {
          name: "Order Create",
          layout: "/admin",
          path: "orders/create",
          component: <OrderCreate />,
          hidden: true,
        },
        {
          name: "Edit Draft Orders",
          layout: "/admin",
          path: "orders/edit/:id",
          component: <OrderEdit />,
          hidden: true,
        },
      ],
    },
    permissions?.container?.tab && {
      name: "Containers",
      layout: "/admin",
      path: "containers",
      icon: <FiBox className="h-6 w-6" />,
      secondary: true,
      children: [
        ...dynamicContainerRoutes,

        {
          name: "Container Details",
          layout: "/admin",
          path: "containers/:id",
          component: <ContainerDetails />,
          hidden: true,
        },
      ],
    },
    permissions?.user?.tab && {
      name: "Users",
      layout: "/admin",
      path: "users",
      icon: <ImUsers className="h-6 w-6" />,
      component: <UsersDashboard />,
    },
    permissions?.user?.tab && {
      name: "Announcement",
      layout: "/admin",
      path: "announcement",
      icon: <GiPartyPopper className="h-6 w-6" />,
      component: <AnnouncementDashboard />,
    },
    permissions?.profile?.tab && {
      name: "Profile",
      layout: "/admin",
      path: "profile",
      icon: <MdPerson className="h-6 w-6" />,
      component: <Profile />,
    },
  ].filter(Boolean);

  return routes;
};

export default RoutesConfig;
